import React from 'react';
import PropTypes from 'prop-types';

import { offlineIcon, onlineIcon } from '../../../assets/svg/index.js';

import useWindowSize from '../../../hooks/useWindowSize.js';
import { useAuth } from '../../../hoc/AuthContext.js';

import { backgroundColor } from '../../../Utils/CommonFunctions.js';

export default function RibbonTag({ showText, channels }) {
  const isOnline = channels?.includes("ONLINE");
  const isOffline = channels?.includes("OFFLINE");
  const isMobile = useWindowSize();
  const { integratorTheme } = useAuth();

  const baseClasses = `
    absolute z-10 top-1 left-0 hidden md:flex items-center gap-1
    font-Inter-Tight font-medium text-[10px] text-white
    py-1 px-1 rounded-tl-[4px] rounded-bl-[4px]
    whatsNewRibbon rounded overflow-hidden
  `;

  const textClasses = `
    inline-block whitespace-nowrap
    transition-all duration-500 ease-in-out
    ${showText || isMobile
      ? "w-auto opacity-100 translate-x-0"
      : "w-0 opacity-0 -translate-x-full"
    }
  `;

  if (isOnline && isOffline) {
    return (
      <div
        style={{ backgroundColor: backgroundColor(integratorTheme) }}
        className={` absolute z-10 top-1 left-0 flex items-center gap-1 font-Inter-Tight font-medium text-[10px]
       text-white  rounded-tl-[4px] rounded-bl-[4px] ${showText || isMobile ? "whatsNewRibbon py-1 px-1" : ""} rounded
      drop-shadow-lg overflow-hidden`}>
        <span className={`inline-block whitespace-nowrap transition-all duration-500 ease-in-out
           ${showText || isMobile ? "w-auto opacity-100 translate-x-0" : "w-0 opacity-0 -translate-x-full"}`}>
          Online/Offline</span>
      </div>
    );
  }

  if (isOnline || isOffline) {
    const icon = isOnline ? onlineIcon : offlineIcon;
    const text = isOnline ? "Online" : "Offline";

    return (
      <div style={{ backgroundColor: backgroundColor(integratorTheme) }} className={baseClasses}>
        <img src={icon} alt={text} className="inline-block w-5 h-5" />

        <div className="overflow-hidden">
          <span className={textClasses}> {text} </span>
        </div>
      </div>
    );
  }

  return null;
};

RibbonTag.propTypes = {
  showText: PropTypes.bool.isRequired,
};